<template>
  <div class="w-100 h-100">
    <h3>Feature Requests

    <b-button v-b-modal="'new_feature_request_modal'" variant="success" class="ml-4" style="float: right; margin-right: 20px;">New Feature Request</b-button>
    </h3>
    <br />
    <b-table striped hover :fields="fields" :items="features" :current-page="currentPage"
      :per-page="perPage" :tbody-tr-class="rowClickableClass" @row-clicked="rowClicked">
      <template v-slot:cell(sample_files)="data">
        <div v-for="sample_file in data.item.sample_files" :key="sample_file.url" style="width: 100%;">
          <b-link :href="sample_file.url" target="_blank" style="font-size: small;" >{{ sample_file.name }}</b-link>
        </div>
        <span v-if="data.item.sample_files.length == 0" style="font-size: small; font-style: italic;">No files submitted</span>
      </template>

      <template v-slot:cell(readable_status)="data" v-if="inMyGroups(['Feature Request Authorizer'])">
        <div v-on:click.prevent.stop="disableRow">
        <b-form-select v-model="data.item.status" :options="status_options" @change="changeState(data.index)" @click="disableRow"></b-form-select>
        </div>
      </template>
      
    </b-table>
    <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    

    <b-modal id="new_feature_request_modal" ref="new_feature_request_modal" size="l" title="New Portal Feature Request" @ok="submit_modal">
      Feature Type <br />
      <b-form-select v-model="selected" :options="options"></b-form-select>
      <br /><br />
      Description<br />
      <b-form-textarea id="new_feature_description" rows="6" v-model="new_description" placeholder="Describe your feature request, including data points and/or aggregation equations."></b-form-textarea>
      <br />
      Example File Upload <br />
      <input type="file" @change="onFileSelected" class="ml-4"><br /><span style="font-style: italic; font-size: small;">You can add more files after submitting</span>
      <div v-if="state" style="font-style: italic; width: 100%; text-align: center;">
          {{ state }}
      </div>
    </b-modal>

    <b-modal id="edit_feature_modal" ref="edit_feature_modal" size="l" title="Edit Portal Feature Request" @ok="save_modal">
      Feature Type <br />
      <b-form-select v-model="edit_type" :options="options"></b-form-select>
      <br /><br />
      Description<br />
      <b-form-textarea id="edit_feature_description" rows="6" v-model="edit_description" placeholder="Describe your feature request, including data points and/or aggregation equations."></b-form-textarea>
      <div v-if="edit_state" style="font-style: italic; width: 100%; text-align: center;">
          {{ edit_state }}
      </div>
      <br />
      Files<br />
      <span v-if="edit_files.length == 0">You have not uploaded any files yet.</span>
      <b-row v-for="(sample_file, index) in edit_files" :key="sample_file.url">
        <b-col cols="1" class="remove-link">
          <b-button variant="danger" v-if="enableFile(index) == false" class="remove-button" size="sm" @click="unRemoveFile(index)">X</b-button>
          <b-button class="remove-button" v-if="enableFile(index) == true" size="sm" @click="removeFile(index)">X</b-button>
          </b-col>
        <b-col>
          <b-link :href="sample_file.url" target="_blank" v-if="enableFile(index) == false" style="font-size: small; text-decoration: line-through;">{{ sample_file.name }}</b-link>
          <b-link :href="sample_file.url" target="_blank" v-if="enableFile(index) == true" style="font-size: small;" >{{ sample_file.name }}</b-link>
        </b-col>
      </b-row>
      <b-row v-for="new_file in additional_files" :key="new_file.url" v-bind:class="{ hide: new_file.disabled }">
        <b-col cols="1" class="remove-link" :data-id="new_file.id">
          <b-button class="remove-button" size="sm" @click="removeNewFile(new_file.id)">X</b-button>
          </b-col>
        <b-col>
          <b-form-file
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            :data-file="new_file.id"
            @change="selectedNewFile"
            :value="new_file.file"
          ></b-form-file>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-button variant="success" class="ml-3" size="sm" @click="addNewFileInput">Add File</b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "formatted_timestamp", sortable: true, label: "Date" },
        { key: "feature_type" },
        { key: "user_requested", label: "Requested By" },
        { key: "description" },
        { key: "readable_status", label: "Status" },
        { key: "sample_files" }
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      features: [],
      state: null,
      selected: null,
      options: [
          {
              value: null,
              text: 'Please select a feature type'
          },
          {
              value: 'chart',
              text: 'Chart'
          },
          {
              value: 'report',
              text: 'Report'
          },
          {
              value: 'table',
              text: 'Data Table'
          }
      ],
      status_options: [
          {
            value: 'UNDER_REVIEW',
            text: 'Under Review'
          },
          {
            value: 'FEEDBACK',
            text: 'Feedback Required'
          },
          {
            value: 'APPROVED',
            text: 'Approved'
          },
          {
            value: 'DECLINED',
            text: 'Declined'
          },
          {
            value: 'COMPLETED',
            text: 'Completed'
          },
      ],
      sampleFile: null,
      new_description: '',
      edit_type: null,
      edit_description: null,
      edit_id: null,
      edit_state: null,
      row_clicked_index: null,
      edit_files: [],
      files_to_remove: [],
      additional_files: [],
      current_newfile_id: 0,
      original_status: []
    };
  },
  computed: {
    ...mapState('user', ['user', 'myGroups']),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/feature-requests/get_list").then(response => {
      for(var i = 0; i < response.data.length; i++){
        for(var j = 0; j < response.data[i].sample_files.length; j++){
          response.data[i].sample_files[j].url = process.env.VUE_APP_AXIOS_BASE_URL + response.data[i].sample_files[j].url;
        }
        that.original_status.push(response.data[i].status);
      }
      that.features = response.data;
      that.totalRows = response.data.length;
    }).catch(error => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    selectedNewFile(event){
      // find the additional files element this belongs to
      var file_id = event.srcElement.attributes[0].value;
      var new_index = -1;
      for(var i = 0; i < this.additional_files.length; i++){
        if(this.additional_files[i].id == file_id){
          new_index = i;
          break;
        }
      }
      if(new_index >= 0){
        this.additional_files[new_index].file = event.target.files[0];
      }
    },
    rowClickableClass(){
      return "clickable";
    },
    changeState(index){
      // get the new state
      var new_status = this.features[index].status;
      if(confirm("Save status as "+new_status+"?")){
        const fd = new FormData();
        fd.append('status', new_status);
        HTTP.post('/kenya/feature-requests/edit/'+this.features[index].id+'/', fd).then((response) => {
          alert("Status saved!");
          for(var j = 0; j < response.data.sample_files.length; j++){
            response.data.sample_files[j].url = process.env.VUE_APP_AXIOS_BASE_URL + response.data.sample_files[j].url;
          }
          this.features.splice(index, 1, response.data);
        });
      }
      else{
        // revert it
        this.features[index].status = this.original_status[index];
      }
    },
    disableRow(){
      // stupid empty function to prevent clicking propegating to the parent row
    },
    removeNewFile(file_id){
      var new_index = -1;
      for(var i = 0; i < this.additional_files.length; i++){
        if(this.additional_files[i].id == file_id){
          new_index = i;
          break;
        }
      }

      if(new_index >= 0){
        this.additional_files[new_index].disabled = true;
      }
    },
    addNewFileInput(){
      this.current_newfile_id += 1;
      this.additional_files.push({
        id: this.current_newfile_id,
        disabled: false,
        file: null
      });
    },
    enableFile(index){
      if(this.files_to_remove.indexOf(index) == -1){
        return true;
      }
      return false;
    },
    removeFile(index){
      if(this.files_to_remove.indexOf(index) == -1){
        this.files_to_remove.push(index);
      }
    },
    unRemoveFile(index){
      var index_to_splice = this.files_to_remove.indexOf(index);
      this.files_to_remove.splice(index_to_splice, 1);
    },
    rowClicked(record, index){
      let that = this;
      that.edit_type = that.features[index].feature_type;
      that.edit_description = that.features[index].description;
      that.edit_id = that.features[index].id;
      that.row_clicked_index = index;
      that.edit_files = that.features[index].sample_files;
      that.$refs['edit_feature_modal'].show();

    },
    onFileSelected: function(event) {
        this.sampleFile = event.target.files[0];
    },

    submit_modal(bvModalEvt){
        let that = this;
        bvModalEvt.preventDefault();
        that.state = 'Saving...';
        
        const fd = new FormData();
        if(that.sampleFile != null){
            fd.append('file', that.sampleFile, that.sampleFile.name);
        }
        fd.append('type', that.selected);
        fd.append('description', that.new_description);
        HTTP.post('/kenya/feature-requests/new/', fd).then((response) => {
            alert("Your submission has been saved!");
            that.features.push(response.data);
            that.$refs['new_feature_request_modal'].hide();
            that.sampleFile = null;
            that.new_description = '';
            that.selected = null;
            that.state = null;
        }).catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    save_modal(bvModalEvt){
        let that = this;
        bvModalEvt.preventDefault();
        that.edit_state = 'Saving...';
        var i = 0;

        const fd = new FormData();
        fd.append('type', that.edit_type);
        fd.append('description', that.edit_description);

        // loop through any files they want to add
        for(i = 0; i < that.additional_files.length; i++){
          if(that.additional_files[i].disabled == false && that.additional_files[i].file != null){
            fd.append('file_'+that.additional_files[i].id, that.additional_files[i].file, that.additional_files[i].file.name);
          }
        }

        // find the list of files to remove, if any
        var list_of_files_to_remove = [];
        for(i = 0; i < that.files_to_remove.length; i++){
          var file_index = that.files_to_remove[i];
          list_of_files_to_remove.push(that.edit_files[file_index].id);
        }
        fd.append('remove_files', JSON.stringify(list_of_files_to_remove));

        HTTP.post('/kenya/feature-requests/edit/'+that.edit_id+'/', fd).then((response) => {
            alert("Your submission has been saved!");
            for(var j = 0; j < response.data.sample_files.length; j++){
              response.data.sample_files[j].url = process.env.VUE_APP_AXIOS_BASE_URL + response.data.sample_files[j].url;
            }
            that.features.splice(that.row_clicked_index, 1, response.data);
            that.$refs['edit_feature_modal'].hide();
            that.edit_description = '';
            that.edit_type = null;
            that.edit_id = null;
            that.row_clicked_index = null;
            that.edit_state = null;
            that.edit_files = [];
            that.files_to_remove = [];
            that.additional_files = [];
            that.current_newfile_id = [];
        }).catch(error => {
          HandleErrors.HandleErrors(error);
        });
    }
  }
};
</script>

<style>
.clickable{
  cursor: pointer;
}

.remove-button{
  font-size: x-small;
}

.hide{
  display: none;
}
</style>